import { Organization, OrganizationMember } from '@prisma/client'
import { message } from 'antd'
import { useSdk } from './useSdk'

type Props = {
  organization: Organization
  organizationMember: OrganizationMember
}

export const useEnsureConversation = ({
  organization,
  organizationMember: organizationMember,
}: Props) => {
  const sdk = useSdk({ organizationMember })

  const ensure = async (organizationMemberTo: OrganizationMember) => {
    try {
      const conversation = await sdk.findOneConversation({
        organizationMemberId: organizationMemberTo.id,
      })

      if (conversation) {
        return conversation
      }

      const conversationCreated = await sdk.createConversation({
        organizationMemberIds: [organizationMemberTo.id],
      })

      return conversationCreated
    } catch (error) {
      message.error(`Something went wrong`)
      console.error('Unknown Error', error)
    }
  }

  return { ensure }
}
